import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var DataRouting = require("lib/routing/DataRouting");

var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");

var AllMonthsLogTable = require("components/reading/logs/AllMonthsLogTable");
var ItemHeader = require("components/data/subjects/shared/ItemHeader");
var Spinner = require("components/utility/Spinner");
var NoActivityBlock = require("components/data/subjects/shared/NoActivityBlock");
var EmptyState = require("components/data/EmptyState");
var UIActions = require("lib/actions/UIActions");
var PaywallModal = require("components/users/teachers/PaywallModal");
var Features = require("lib/account/Features")

require("data/data_log_tables");

function propsToConditions(props) {
	var conditions = _.pick(props, 
		"startDate", "endDate", "textVariety", "textID", "userIDs"
	);

	conditions.timeKey = "log_date";

	return conditions;
}

@connect(
	(state, props) => ({
		logs: ReadingSelectors.logs({
			state, conditions: propsToConditions(props)
		}),
		loading: ReadingSelectors.isLoadingLogs({ state }),
		hasLogReading: Features.isEnabled(Features.LOG_READING)
	}),
	(dispatch, props) => ({
		populateData: () => {
			// TODO: standardize FE requests
			if ($wr.isLargeRequest(props.userIDs)) {
				var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID")
				conditions.timeKey = 'log_date'
				var actionFunction = ReadingActions.fetchLogs
				var options = { cache: true }
				return new Promise(function (resolve, reject) {
					$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, (results) => {
						resolve(results);
					})
				}).catch(() => console.log("Logs failed to load"))
			} else {
				return dispatch(ReadingActions.fetchLogs({
					conditions: propsToConditions(props),
					cache: true
				}));
			}
		},
		openLogReadingPaywall: () => 
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.LOG_READING }))
	})
)
@providePopulateData()
class DataLogTables extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		LuckyOrangeClient.tagComponent("DataLogTables");
	}

	fetchUserLogs(userID) {
		var logs = _.where(this.props.logs, { user_id: userID });
		logs = _.sortBy(logs, "log_date").reverse();
		return logs;
	}

	render() {
		if (!this.props.condensedLayout) {
			var logsDisplay = []
			// renders hidden component used for printing
  			// without pagination
			var printableLogsDisplay = []
			var studentsWithoutLogs = []

			_.each(this.props.userIDs, (studentID) => {
				var logs = _.where(this.props.logs, { user_id: studentID });
				if (logs.length > 0) {
					logsDisplay.push(
						<div key={ studentID }>
							<ItemHeader studentID={ studentID } pageBreak />
							<AllMonthsLogTable initExpanded embedded logs={ logs } key={ studentID }
								softMax={ this.props.softMaxPerTable } />
						</div>
					)
					printableLogsDisplay.push(
						<div key={studentID}>
							<ItemHeader studentID={studentID} pageBreak />
							<AllMonthsLogTable initExpanded embedded logs={logs} key={studentID}
								softMax={_.size(logs)} />
						</div>
					)
				} else {
					studentsWithoutLogs.push(studentID)
				}
			});
			if (studentsWithoutLogs.length > 0) {
				var noLogs = <NoActivityBlock userIDs={ studentsWithoutLogs } contentType="Reading Logs" />
			}
			var display = (
				<div>
					<span className='hideOnPrint'>
						{logsDisplay}
					</span>
					<span className='showOnPrint'>
						{printableLogsDisplay}
					</span> 
					{ noLogs }
				</div>
			)
		} else {
			if (this.props.logs.length > 0) {
				var selectedUserIDs = _.sortBy(this.props.userIDs, (userID) => {
					var logs = this.fetchUserLogs(userID);
					if (logs.length > 0) {
						return logs[0].log_date
					} else {
						return "1900-01-01";
					}
				}).reverse()
				selectedUserIDs = _.first(selectedUserIDs, 3)
				var logsDisplay = _.map(selectedUserIDs, (studentID) => {
					var logs = _.first(this.fetchUserLogs(studentID), 3)
					if (logs.length > 0) {
						var header = (
							<ItemHeader studentID={ studentID } pageBreak />
						);
						return (
							<div key={ studentID }>
								{ header }
								<AllMonthsLogTable initExpanded embedded condensedLayout
									logs={ logs } key={ studentID } 
									softMax={ this.props.softMaxPerTable } />
							</div>
						)
					}
				});
				// renders hidden component used for printing
  				// without pagination
				var printableDisplay = _.map(selectedUserIDs, (studentID) => {
					var logs = _.first(this.fetchUserLogs(studentID), 3)
					if (logs.length > 0) {
						var header = (
							<ItemHeader studentID={studentID} pageBreak />
						);
						return (
							<div key={studentID}>
								{header}
								<AllMonthsLogTable initExpanded embedded condensedLayout
									logs={logs} key={studentID}
									softMax={_.size(logs)} />
							</div>
						)
					}
				});

				var display = (
					<div>
						<span className='hideOnPrint'>
							{logsDisplay}
						</span>
						<span className='showOnPrint'>
							{printableLogsDisplay}
						</span> 
					</div>
				)
			} else {
				if (!this.props.hasLogReading) {
					var silverText  =  (
						<p className="silverTextContainer">
							<i>Reading Logs</i> are a part of Whooo's Reading Silver.
							<a className="btn btn-link" onClick={ this.props.openLogReadingPaywall }>
								Learn about WR Silver
							</a>
						</p>
					)
				}
				var emptyState = <EmptyState type={ LOGS } />
			}
		}

		return (
			<div className="dataLogTables">
				{ silverText }
				{ emptyState }	
				{ display }
				{ printableDisplay }
			</div>
		)
	}
}
var LOGS = "logs";
DataLogTables.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from above
	userIDs: PropTypes.array,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	showFullData: PropTypes.bool,
	condensedLayout: PropTypes.bool,
	softMaxPerTable: PropTypes.number,

	// Data from @connect
	loading: PropTypes.bool,
	logs: PropTypes.array,
	openLogReadingPaywall: PropTypes.func,
	hasLogReading: PropTypes.bool,

	// Handlers from @connect
	populateData: PropTypes.func,

	// URL params
	studentList: PropTypes.string,
})

module.exports = DataLogTables;


// WEBPACK FOOTER //
// ./modules/components/data/subjects/DataLogTables.js